import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <h1>404</h1>
      <p>Page not found</p>

      <Link to="/" style={{ color: "#007bff" }}>
        Go back home
      </Link>
    </div>
  );
}
